import React from 'react';
import { Modal } from 'antd';
import { Button } from 'components/atoms';

interface CheckProjectStepModalProps {
  visible: boolean;
  title: string;
  message: string;
  onCancel?: () => void;
  onOk: () => void;
}

const CheckProjectStepModal = ({
  visible,
  title,
  message,  
  onCancel,
  onOk,
}: CheckProjectStepModalProps): React.ReactElement => {
  /* ======================================================
   * methods
   * ====================================================== */
  const getButtons = () => (
    <div className="text-center">
      <Button
        danger
        onClick={() => onOk()}
      >
        삭제
      </Button>
      {onCancel && (<Button type="primary" onClick={() => onCancel()}>유지</Button>)}
    </div>
  );

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Modal title={title} open={visible} footer={getButtons()} onCancel={onCancel} centered>
      <p style={{whiteSpace:"pre-wrap"}}>{message}</p>
    </Modal>
  );
};

export default CheckProjectStepModal;
